import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type StartFloatingTimerMutationVariables = Types.Exact<{
  input: Types.StartFloatingTimerInput;
}>;


export type StartFloatingTimerMutation = { __typename?: 'Mutation', startFloatingTimer: { __typename?: 'FloatingTimeEntryPayload', floatingTimeEntry?: { __typename?: 'FloatingTimeEntryStateData', floatingTimeEntryId: string, workerId: string, status: Types.FloatingTimeEntryStatus, startTime?: Types.TDateISO | null, endTime?: Types.TDateISO | null, duration?: unknown | null, allocatedDuration: unknown, remainingDuration: unknown, allocations: Array<{ __typename?: 'FloatingTimeEntryAllocationData', taskAssignmentId: string, duration: unknown }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type StopFloatingTimerMutationVariables = Types.Exact<{
  input: Types.StopFloatingTimerInput;
}>;


export type StopFloatingTimerMutation = { __typename?: 'Mutation', stopFloatingTimer: { __typename?: 'FloatingTimeEntryPayload', floatingTimeEntry?: { __typename?: 'FloatingTimeEntryStateData', floatingTimeEntryId: string, workerId: string, status: Types.FloatingTimeEntryStatus, startTime?: Types.TDateISO | null, endTime?: Types.TDateISO | null, duration?: unknown | null, allocatedDuration: unknown, remainingDuration: unknown, allocations: Array<{ __typename?: 'FloatingTimeEntryAllocationData', taskAssignmentId: string, duration: unknown }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LinkFloatingTimeEntryMutationVariables = Types.Exact<{
  input: Types.LinkFloatingTimeEntryInput;
}>;


export type LinkFloatingTimeEntryMutation = { __typename?: 'Mutation', linkFloatingTimeEntry: { __typename?: 'FloatingTimeEntryPayload', floatingTimeEntry?: { __typename?: 'FloatingTimeEntryStateData', floatingTimeEntryId: string, workerId: string, status: Types.FloatingTimeEntryStatus, startTime?: Types.TDateISO | null, endTime?: Types.TDateISO | null, duration?: unknown | null, allocatedDuration: unknown, remainingDuration: unknown, allocations: Array<{ __typename?: 'FloatingTimeEntryAllocationData', taskAssignmentId: string, duration: unknown }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DiscardFloatingTimeEntryMutationVariables = Types.Exact<{
  input: Types.DiscardFloatingTimeEntryInput;
}>;


export type DiscardFloatingTimeEntryMutation = { __typename?: 'Mutation', discardFloatingTimeEntry: { __typename?: 'FloatingTimeEntryPayload', floatingTimeEntry?: { __typename?: 'FloatingTimeEntryStateData', floatingTimeEntryId: string, workerId: string, status: Types.FloatingTimeEntryStatus, startTime?: Types.TDateISO | null, endTime?: Types.TDateISO | null, duration?: unknown | null, allocatedDuration: unknown, remainingDuration: unknown, allocations: Array<{ __typename?: 'FloatingTimeEntryAllocationData', taskAssignmentId: string, duration: unknown }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const StartFloatingTimerDocument = new TypedDocumentString(`
    mutation StartFloatingTimer($input: StartFloatingTimerInput!) {
  startFloatingTimer(input: $input) {
    floatingTimeEntry {
      ...FloatingTimeEntryState
    }
    errors {
      code
      message
    }
  }
}
    fragment FloatingTimeEntryState on FloatingTimeEntryStateData {
  floatingTimeEntryId
  workerId
  status
  startTime
  endTime
  duration
  allocatedDuration
  remainingDuration
  allocations {
    taskAssignmentId
    duration
  }
}`);
export const StopFloatingTimerDocument = new TypedDocumentString(`
    mutation StopFloatingTimer($input: StopFloatingTimerInput!) {
  stopFloatingTimer(input: $input) {
    floatingTimeEntry {
      ...FloatingTimeEntryState
    }
    errors {
      code
      message
    }
  }
}
    fragment FloatingTimeEntryState on FloatingTimeEntryStateData {
  floatingTimeEntryId
  workerId
  status
  startTime
  endTime
  duration
  allocatedDuration
  remainingDuration
  allocations {
    taskAssignmentId
    duration
  }
}`);
export const LinkFloatingTimeEntryDocument = new TypedDocumentString(`
    mutation LinkFloatingTimeEntry($input: LinkFloatingTimeEntryInput!) {
  linkFloatingTimeEntry(input: $input) {
    floatingTimeEntry {
      ...FloatingTimeEntryState
    }
    errors {
      code
      message
    }
  }
}
    fragment FloatingTimeEntryState on FloatingTimeEntryStateData {
  floatingTimeEntryId
  workerId
  status
  startTime
  endTime
  duration
  allocatedDuration
  remainingDuration
  allocations {
    taskAssignmentId
    duration
  }
}`);
export const DiscardFloatingTimeEntryDocument = new TypedDocumentString(`
    mutation DiscardFloatingTimeEntry($input: DiscardFloatingTimeEntryInput!) {
  discardFloatingTimeEntry(input: $input) {
    floatingTimeEntry {
      ...FloatingTimeEntryState
    }
    errors {
      code
      message
    }
  }
}
    fragment FloatingTimeEntryState on FloatingTimeEntryStateData {
  floatingTimeEntryId
  workerId
  status
  startTime
  endTime
  duration
  allocatedDuration
  remainingDuration
  allocations {
    taskAssignmentId
    duration
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    StartFloatingTimer: build.mutation<StartFloatingTimerMutation, StartFloatingTimerMutationVariables>({
      query: (variables) => ({ document: StartFloatingTimerDocument, variables })
    }),
    StopFloatingTimer: build.mutation<StopFloatingTimerMutation, StopFloatingTimerMutationVariables>({
      query: (variables) => ({ document: StopFloatingTimerDocument, variables })
    }),
    LinkFloatingTimeEntry: build.mutation<LinkFloatingTimeEntryMutation, LinkFloatingTimeEntryMutationVariables>({
      query: (variables) => ({ document: LinkFloatingTimeEntryDocument, variables })
    }),
    DiscardFloatingTimeEntry: build.mutation<DiscardFloatingTimeEntryMutation, DiscardFloatingTimeEntryMutationVariables>({
      query: (variables) => ({ document: DiscardFloatingTimeEntryDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useStartFloatingTimerMutation, useStopFloatingTimerMutation, useLinkFloatingTimeEntryMutation, useDiscardFloatingTimeEntryMutation } = injectedRtkApi;
